export default "__VITE_ASSET__BrhGorpS__"